import { render, staticRenderFns } from "./HandicapAppendixData.vue?vue&type=template&id=2e462fa6&scoped=true"
import script from "./HandicapAppendixData.vue?vue&type=script&lang=js"
export * from "./HandicapAppendixData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e462fa6",
  null
  
)

export default component.exports